import { SPECIAL_BUILDINGS } from "@dein-go-city/shared";
// Company type display config — colours drawn from the game's building palette. Shared
// between BuildingTooltip (desktop hover) and BuildingInfoOverlay (mobile tap) so both
// surfaces render a company/townhall/special building identically.
export const TYPE_CONFIG = {
    service: { label: "Dienstleistung", color: "#7ab8f5" },
    mechanic: { label: "Handwerk", color: "#f5a742" },
    forestry: { label: "Forstwirtschaft", color: "#5ab870" },
    agriculture: { label: "Landwirtschaft", color: "#d4b44a" },
    metalworks: { label: "Metallverarbeitung", color: "#a8b8c8" },
};
export const TOWNHALL_COLOR = "#c8a882";
export const SPECIAL_COLOR = "#5a9e78";
export function typeStyleFor(kind, companyType, specialType) {
    if (kind === "townhall")
        return { label: "Rathaus", color: TOWNHALL_COLOR };
    if (kind === "special") {
        const def = specialType ? SPECIAL_BUILDINGS[specialType] : null;
        return { label: def?.name ?? "Sonderbau", color: SPECIAL_COLOR };
    }
    return (TYPE_CONFIG[companyType ?? ""] ?? {
        label: companyType ?? "",
        color: "#888",
    });
}
